/*
 * QmEnvironmentConfig v1.0.0
 */
'use strict'

export default function QmEnvironmentConfig (Vue) {

  /**
   *
   * @returns string api base url
   */
  Vue.prototype.$getApiHost = function () {
    const hostname = window.location.hostname
    var apiHost = null

    switch (hostname) {

      // keller prod
      case 'survey.kellerswissgroup.com':
        apiHost = 'https://survey-api.kellerswissgroup.com'
        break

      // keller2 test
      case 'survey.keller2.qualimover.com':
        apiHost = 'https://survey-api.keller2.qualimover.com'
        break

      // irish prod
      case 'survey-irish.qualimover.com':
        apiHost = 'https://survey-api-irish.qualimover.com'
        break

      // irish2 test
      case 'qm-survey-webapp-irish2.meta.ditoy.com':
        apiHost = 'https://qm-survey-api-irish2.meta.ditoy.com'
        break

      // donath prod
      case 'survey-donath.qualimover.com':
        apiHost = 'https://survey-api-donath.qualimover.com'
        break

      // donath2 test
      case 'survey.donath2.qualimover.com':
        apiHost = 'https://survey-api.donath2.qualimover.com'
        break

      // local development, currently connects to keller2 survey api and keller2 qualimover backend
      case 'localhost':
      case 'qm-survey-webapp.meta.ditoy.com':
      default:
        // apiHost = 'http://localhost:8055'                           // local qualimover-survey-rest-api
        apiHost = 'https://survey-api.keller2.qualimover.com'         // keller2
        // apiHost = 'https://survey-api.donath2.qualimover.com'    // donath2
        // apiHost = 'https://qm-survey-api-irish2.meta.ditoy.com'  // irish2
        break
    }

    return apiHost
  }


  /**
   *
   * @returns array of available languages
   */
  Vue.prototype.$getLanguages = function () {
    const hostname = window.location.hostname
    var languages = []

    switch (hostname) {

      // keller
      case 'survey.kellerswissgroup.com':
      case 'survey.keller2.qualimover.com':
      case 'survey.keller3.qualimover.com':
        languages = [
          'en_US',
          'de_CH',
          'fr_CH',
          'it_CH'
        ]
        break

      // donath
      case 'survey-donath.qualimover.com':
      case 'survey.donath.qualimover.com':
      case 'survey.donath2.qualimover.com':
      case 'qm-survey-webapp-donath2.meta.ditoy.com':
        languages = [
          'en_US',
          'de_DE',
        ]
        break

      // irish
      case 'survey-irish.qualimover.com':
      case 'survey.irish.qualimover.com':
      case 'survey.irish2.qualimover.com':
      case 'qm-survey-webapp-irish2.meta.ditoy.com':
        languages = [
          'en_US',
          'de_DE'
        ]
        break

      // default (for local development) - all options
      default:
        languages = [
          'en_US',
          'de_DE',
          'de_CH',
          'fr_FR',
          'fr_CH',
          'it_IT',
          'it_CH'
        ]
    }

    return languages
  }

  /**
   * @return bool true if the qm partner uses metric units
   *
   * irish-relo has imperial units, all others have metric units.
   * The unit system only affetcs the display of the labels and not the values
   */
  Vue.prototype.$hasMetricUnits = function () {
    const hostname = window.location.hostname
    switch (hostname) {

      // local development: switch to test with metric or non-metric units
      case 'localhost':
        return true

      // keller: metric units
      case 'survey.kellerswissgroup.com':
      case 'survey.keller2.qualimover.com':
        return true

      // donath: metric units
      case 'survey-donath.qualimover.com':
      case 'survey.donath.qualimover.com':
      case 'survey.donath2.qualimover.com':
        return true

      // irish: *NON*-metric units
      case 'survey-irish.qualimover.com':
      case 'survey.irish.qualimover.com':
      case 'survey.irish2.qualimover.com':
      case 'qm-survey-webapp-irish2.meta.ditoy.com':
        return false
    }

    return true
  }

}

QmEnvironmentConfig.version = '1.0.0'



//////////////////
// WEBPACK FOOTER
// ./config/qm-environment-config.js
// module id = 278
// module chunks = 4